import { type FC, type ReactNode } from "react";

import { Control } from "@snapchat/snap-design-system";

import { controlStyle, itemContainer } from "./LensStats.module.css";

interface LensStatsItemProps {
    label: ReactNode;
    tooltip?: ReactNode;
    show?: boolean;
    children?: ReactNode;
}

export const LensStatsItem: FC<LensStatsItemProps> = ({ label, tooltip, children, show = true }) => {
    if (!show) {
        return null;
    }

    return (
        <div className={itemContainer}>
            <Control label={label} tooltip={tooltip} className={controlStyle}>
                {children}
            </Control>
        </div>
    );
};
